import {
    PostsPromoSwiperSlide,
    PromoPostsSwiperStyled,
    SwiperContainer,
} from "./PostsPromoSlider.styles";
import React from "react";
import { Navigation, Pagination } from "swiper/modules";

export function PostsPromoSlider({ slides }: { slides: React.ReactElement[] }) {
    if (!slides) {
        return null;
    }

    return (
        <SwiperContainer>
            <PromoPostsSwiperStyled
                pagination={{
                    clickable: false,
                    dynamicBullets: true,
                    dynamicMainBullets: 3,
                }}
                modules={[Pagination, Navigation]}
                spaceBetween={16}
                centeredSlides={true}
                slidesPerView={1.26}
                loop={true}
                direction={"horizontal"}
                navigation={{
                    disabledClass: "hidden",
                }}
                initialSlide={0}
            >
                {slides.map((renderedItem, key) => (
                    <PostsPromoSwiperSlide key={key}>
                        <>{renderedItem}</>
                    </PostsPromoSwiperSlide>
                ))}
            </PromoPostsSwiperStyled>
        </SwiperContainer>
    );
}
